import { Search } from "lucide-react";
import { Section, LockableCard } from "@/components/plan/common";

const COLORS = {
  indigo: "bg-indigo-50 text-indigo-700 border-indigo-100",
  emerald: "bg-emerald-50 text-emerald-700 border-emerald-100",
  zinc: "bg-zinc-50 text-zinc-700 border-zinc-100",
  rose: "bg-rose-50 text-rose-700 border-rose-100",
};

function KeywordList({ title, items = [], color }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-2xl p-5 h-full">
      <div className="text-xs uppercase tracking-widest text-zinc-500">{title}</div>
      <div className="mt-3 flex flex-wrap gap-1.5">
        {items.map((k, i) => (
          <span key={`kw-${i}-${k}`} className={`text-xs border px-2 py-1 rounded-full ${COLORS[color]}`}>{k}</span>
        ))}
      </div>
    </div>
  );
}

export default function KeywordSection({ strategy, isFree }) {
  if (!strategy) return null;
  return (
    <Section icon={Search} title="Keyword strategy">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <KeywordList title="High intent" items={strategy.high_intent} color="indigo" />
        <LockableCard locked={isFree}><KeywordList title="Long tail" items={strategy.long_tail} color="emerald" /></LockableCard>
        <LockableCard locked={isFree}><KeywordList title="Informational" items={strategy.informational} color="zinc" /></LockableCard>
        <LockableCard locked={isFree}><KeywordList title="Negative keywords" items={strategy.negative_keywords} color="rose" /></LockableCard>
      </div>
    </Section>
  );
}
